// src/components/HomeContent.jsx
import React from 'react';
import { Twitter, Instagram, Rss } from 'lucide-react';
import { PRIMARY_FONT } from '../constants';
import ScribbleText from './ScribbleText';

const HomeContent = () => {
  return (
    <div className="max-w-3xl mx-auto text-white relative">

      {/* Ink spot decoration */}
      <div className="ink-spot" style={{ top: '20px', right: '30px', width: '50px', height: '50px' }} />
      <div className="coffee-stain" style={{ top: '180px', right: '-20px', opacity: 0.5 }} />

      {/* Hero card — notebook style */}
      <div className="notebook-card tape-strip w-11/12 mx-auto p-6 mb-10 mt-4">
        <h2
          className="font-handwritten text-4xl font-bold mb-2 tracking-tight text-center text-sky-200"
          style={{ fontFamily: PRIMARY_FONT }}
        >
          Beatmaker, singer and Mexican
        </h2>
        <p className="font-handwritten text-center text-xl text-white text-opacity-60">
          Reggaeton // lo-fi // dancehall // pop
        </p>
        <p className="font-handwritten text-center text-sm text-white text-opacity-25 mt-2" style={{ transform: 'rotate(-1deg)' }}>
          <ScribbleText>profesional serio</ScribbleText>{' '}
          haciendo música desde mi cuarto
        </p>
      </div>

      {/* Manifiesto link */}
      <div className="notebook-card max-w-72 mx-auto p-4 mb-10 page-fold" style={{ transform: 'rotate(0.5deg)' }}>
        <p className="font-handwritten text-center text-lg text-white text-opacity-60">
          Listen Tropical music on:
        </p>
        <a href="https://manifiesto.rickyzafiro.com" target="_blank" rel="noopener noreferrer">
          <h3 className="font-handwritten font-bold text-center text-xl rough-underline text-sky-300 hover:text-sky-200 transition-colors inline-block mx-auto w-full">
            Manifiesto Sonidero
          </h3>
        </a>
        <span className="doodle-arrow block text-center mt-1">^^ click aqui ^^</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

        {/* Latest Release card */}
        <div className="notebook-card w-11/12 max-w-96 mx-auto p-6 page-fold" style={{ transform: 'rotate(-0.6deg)' }}>
          <div className="smudge" style={{ top: '12px', right: '20px' }} />
          <h3
            className="font-handwritten text-2xl font-bold mb-4 tracking-tight text-center"
            style={{ fontFamily: PRIMARY_FONT }}
          >
            Latest Release
          </h3>
          <div className="flex aspect-w-16 aspect-h-9 mb-4 justify-center">
            <iframe
              title="Flaquita - Latest Release"
              src="https://www.youtube.com/embed/UeUowNEEPJ0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
              className="rounded-sm"
              style={{ border: '1px solid rgba(255,255,255,0.06)' }}
            ></iframe>
          </div>
          <p className="font-handwritten text-xl text-white text-opacity-70">
            "Flaquita," is a perfect fusion of reggaeton and lo-fi. My main goal is to evoke{' '}
            <ScribbleText>felicidad</ScribbleText>{' '}
            <span className="doodle-circle">nostalgia</span>. Enjoy it!
          </p>
        </div>

        {/* Socials card */}
        <div className="notebook-card w-11/12 max-w-96 mx-auto p-6" style={{ transform: 'rotate(0.4deg)' }}>
          <h3
            className="font-handwritten text-2xl font-bold mb-4 tracking-tight text-center"
            style={{ fontFamily: PRIMARY_FONT }}
          >
            Socials
          </h3>
          <div className="flex space-x-6 mb-6 justify-center">
            <button
              type="button"
              className="text-white text-opacity-50 hover:text-sky-300 transition-colors duration-300 jitter-hover"
              aria-label="RSS Feed"
            >
              <Rss size={24} />
            </button>
            <button
              type="button"
              className="text-white text-opacity-50 hover:text-sky-300 transition-colors duration-300 jitter-hover"
              aria-label="Twitter"
            >
              <Twitter size={24} />
            </button>
            <button
              type="button"
              className="text-white text-opacity-50 hover:text-sky-300 transition-colors duration-300 jitter-hover"
              aria-label="Instagram"
            >
              <Instagram size={24} />
            </button>
          </div>

          <blockquote
            className="border-l-2 border-sky-200 border-opacity-30 pl-4 italic mb-6 font-handwritten text-xl text-white text-opacity-70"
            style={{ transform: 'rotate(-0.3deg)' }}
          >
            "Si mi música llega a inspirar a algunos, valdrá la pena el{' '}
            <ScribbleText>dinero</ScribbleText> tiempo y esfuerzo invertido".
          </blockquote>

          {/* Small doodle note */}
          <p className="font-handwritten text-xs text-white text-opacity-20 text-right" style={{ transform: 'rotate(1deg)' }}>
            * nota: agregar links reales luego...
          </p>
        </div>

        <div className="h-12"></div>
      </div>
    </div>
  );
};

export default HomeContent;
